export enum WidgetUserTypeEnum {
  User,
  Developer,
}
